'use client';

import { Box, Flex, type FlexProps, Tag } from '@coolblue-development/freddy';
import { Pushpin } from '@coolblue-development/icons';

type Props = {
  children: string;
  isFixed?: boolean;
  isOptional?: boolean;
  isLarge?: boolean;
  isTextCentered?: boolean;
} & FlexProps;

const BorderedBoxWithTag = (props: Props) => {
  const { children, isFixed, isOptional, isLarge, isTextCentered, ...rest } = props;

  return (
    <Flex
      alignItems={isTextCentered ? 'center' : 'start'}
      justifyContent={isTextCentered ? 'center' : 'space-between'}
      {...rest}
      sx={theme => ({
        width: '100%',
        border: `3px ${isOptional ? 'dashed' : 'solid'} ${theme.color.background.accentedBase}`,
        borderRadius: theme.borderRadius[100],
        padding: theme.spacing[400],
        minHeight: isLarge ? '200px' : 'auto',
        ...rest.sx
      })}
    >
      <Tag>{children}</Tag>

      {isFixed && (
        <Box color='accented'>
          <Pushpin size='large' />
        </Box>
      )}
    </Flex>
  );
};

export default BorderedBoxWithTag;
